export default __webpack_public_path__ + "26c20a74fcc260f919290888a8617f77.jpg";